import api from '../node_modules/js-cookie/dist/js.cookie.js';
import { useState, useCallback } from 'react';
import useInterval from './useInterval.js';

const useConsentApplied = () => {
    const [consentApplied, setConsentApplied] = useState(false);
    const checkConsentApplied = useCallback(() => {
        api.get('OptanonAlertBoxClosed') && setConsentApplied(true);
    }, []);
    useInterval(checkConsentApplied, consentApplied ? undefined : 2000);
    return consentApplied;
};

export { useConsentApplied as default };
//# sourceMappingURL=useConsentApplied.js.map
